module.exports = __webpack_public_path__ + "img/bdg_restart.e5ae34a3.svg";